import {Component, NgModuleFactoryLoader, OnInit} from '@angular/core';
import {SharedService} from '../../../shared/shared.service';
import {LocalStorageService} from 'angular-2-local-storage';
import {ActivatedRoute, Router} from '@angular/router';
import {UsagePaymentsService} from '../usage-payments.service';
import {MatDialog} from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import {DatePipe, TitleCasePipe} from '@angular/common';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import * as FileSaver from 'file-saver';
import {MatSelectModule} from '@angular/material/select';

export interface DailyUsageChargeSummary {
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  esiid: string;
  meterId: string;
  totalUsage: number;
  dailyUsageCharges: DailyUsageCharge[] | undefined;
}

export interface NonRecurringBillingCharge {
  categoryCode: string;
  chargeDate: string;
  chargeDateDisplay: string;
  description: string;
  amount: number;
  webDisplayDate: string;
  dateUsageKey: string;
}

export interface NonRecurringServiceCharge {
	address: string;
	esiid: string;
	meterId: string;
	meterStatus: string;
	nonRecurringServiceCharges: NonRecurringBillingCharge[] | undefined;
}

export interface PaymentRecord {
  secondaryDescription: string;
  secondaryAmount: number;
  categoryCode: string;
  chargeDate: string;
  chargeDateDisplay: string;
  description: string;
  amount: number;
  webDisplayDate: string;
  dateUsageKey: string;
}

export interface DailyUsageCharge {
  usageDate: Date;
  displayDate: string;
  usage: number;
  totalNonTaxedAmount: number;
  totalCost: number;
  averageUsage: number;
	webDisplayDate: string;
	dateUsageKey: string;
}

// A single selectable usage/billing period. Periods can be sourced from any of
// the daily usage, payment, or non-recurring charge collections in the report.
export interface UsageDateOption {
	dateUsageKey: string;
	displayDate: string;
	sortValue: number;
}

export interface SummaryUsageReport {
	customerName: string;
	billingAccountNumber: number;
	meterId: string;
	meterStatus: string;
	serviceAddress: string;
	totalUsage: number;
	averagePrice: number;
	dailyUsageSummaries: DailyUsageChargeSummary[] | undefined;
	nonRecurringBillingCharges: NonRecurringBillingCharge[] | undefined;
	nonRecurringServiceCharges: NonRecurringServiceCharge[] | undefined;
	payments: PaymentRecord[] | undefined;
}

@Component({
  selector: 'app-usage-payment-details',
  templateUrl: './usage-payment-details.component.html',
  styleUrls: ['./usage-payment-details.component.css'],
})
export class UsagePaymentDetailsComponent implements OnInit {
  displayedColumns = ['displayDate', 'usage', 'totalCost'];
	public usageDateOptions: UsageDateOption[] = [];
	public isClicked: boolean;
  public account_no: number;
  public username: any;
  public status: any;
  public street_address1: any;
  public street_address2: any;
  public customer_since: any;
  public service_start_date: any;
  public ser_acc_bal: any;
  public dpp_bal: any;
  public dab_bal: any;
  public esi_id: any;
  public user_id: any;
  public data_list: any;
  public is_monthly_stat: boolean;
  public is_get_statement: boolean;
  public is_loader: boolean;
  public disable_button: boolean;
  public is_loading: boolean;
	public selectedDate: string;
	public report_btn_text = 'Download Usage Summary Report';
  public usage_and_summary_report: SummaryUsageReport | undefined = undefined;

  constructor(
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private titlecasePipe: TitleCasePipe,
    private readonly loader: NgModuleFactoryLoader,
    private sharedService: SharedService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private usagePaymentsService: UsagePaymentsService
  ) {
    this.sharedService.setHeaderTitleDynamicVal('usage_payments', 'Usage History', '');
    if (this.localStorageService.get('token') != null) {
      this.data_list = [];
      this.is_monthly_stat = false;
      this.is_get_statement = false;
      this.is_loader = true;
      this.isClicked = false;
      this.ser_acc_bal = 0.0;
      this.dpp_bal = 0.0;
      this.dab_bal = 0.0;
      this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
        .then(res => {
          this.sharedService.setHeaderTitle('usage_payments');
          if (res.status === 'success' && res.isTerminated === false) {
            if (!res.isEnrolled) {
              this.router.navigate(['./dashboard']);
            } else {
              const person = res.results[0]['personal'][0];
              this.user_id = person['id'];
              this.ser_acc_bal = person.balance.toFixed(2);
              this.username = person.firstName + ' ' + person.lastName;
              this.username = this.titlecasePipe.transform(this.username);
              this.street_address1 = person.billingAddress;
              this.street_address2 = person.city + ', ' + person.state + ' ' + person.zipCode;
              this.account_no = person.accountNumber;
              const service = res.results[0]['service'][0];

              // Used for dataLayer.push
              const dataLayerAccountInfo = res.results[0]['personal'];

              var dataLayerEvent = 'usage payments';
              (window as any).dataLayer.push({ 'event': dataLayerEvent, 'accountID': dataLayerAccountInfo[0].id.toString(), 'accountNumber': dataLayerAccountInfo[0].accountNumber.toString() });

              if (service) {
                this.customer_since = service.serviceStartDate;
                this.esi_id = service.esiId;
              }

              const that = this.sharedService;

             if (service == null) {
               this.status = '';
             } else {
                if (service.status == null) {
                  this.status = '';
                } else {
                  this.status = service.status.replace('_', ' ');
                }
                setTimeout(function () {
                  that.setHeaderErrorMessage('usage_payments', false, 'notification error', '');
                  that.setHeaderUserLoggedIn('usage_payments', true, person);
                }, 10);
             }

			 this.getSUPPdf(undefined, true);
            }
          } else {
            this.localStorageService.remove('token');
            this.router.navigate(['./sign-in']);
          }
        });
    } else {
      this.router.navigate(['./sign-in']);
    }
  }

  ngOnInit() {
  }

	getSUPPdf(mmyy?: string, parseDates: boolean = false) {
		this.is_loading = true;
		const tmp_txt = this.report_btn_text;
		this.report_btn_text = 'File is preparing for download'
		this.disable_button = true;
		const isEnglish = this.sharedService.isEnglish();
		this.usagePaymentsService.getSUP(this.account_no, isEnglish, mmyy)
			.then(async res => {
				if (res.ok) {
					this.usage_and_summary_report = await res.json();

					if (parseDates) {
						this.usageDateOptions = this.usage_and_summary_report
							? this.buildUsageDateOptions(this.usage_and_summary_report)
							: [];

						// Default to the current month (month-to-date). Options are sorted
						// oldest-first, so fall back to the most recent period if the current
						// month isn't present in the report.
						const currentMonthKey = this.getCurrentMonthKey();
						const defaultDate = this.usageDateOptions.find(option => option.dateUsageKey === currentMonthKey)
							|| (this.usageDateOptions.length > 0 ? this.usageDateOptions[this.usageDateOptions.length - 1] : undefined);
						if (defaultDate) {
							this.selectedDate = defaultDate.dateUsageKey;
							this.usagePaymentsService.getSUP(this.account_no, isEnglish, defaultDate.dateUsageKey)
								.then(async res => {
									if (res.ok) {
										this.usage_and_summary_report = await res.json();

										this.is_loader = false;
										this.is_loading = false;
										this.disable_button = false;
										this.report_btn_text = tmp_txt;
									} else {
										this.is_loader = false;
										this.is_loading = false;
										this.disable_button = false;
										this.report_btn_text = tmp_txt;
									}
								})
						} else {
							this.is_loader = false;
							this.is_loading = false;
							this.disable_button = false;
							this.report_btn_text = tmp_txt;
						}

					} else {
						this.is_loader = false;
						this.is_loading = false;
						this.disable_button = false;
						this.report_btn_text = tmp_txt;
					}
				}
			})
			.catch((err) => {
				this.is_loading = false;
				this.report_btn_text = tmp_txt;
				this.disable_button = true;
				this.sharedService.setHeaderErrorMessage('usage_payments', true, 'notification error',
					'There was an issue obtaining your report, please try again.');
			});
	}
	onUsageDateChange(event: any) {
		this.selectedDate = event.target.value;
		this.getSUPPdf(this.selectedDate);
	}

	// A usage period can be present in any of the report's collections
	// (daily usage, payments, or non-recurring charges) and not necessarily all
	// of them. Gather every period from all sources, de-duplicate by dateUsageKey,
	// and return them sorted oldest-first so the earliest period can be selected.
	private buildUsageDateOptions(report: SummaryUsageReport): UsageDateOption[] {
		const options: UsageDateOption[] = [];
		const seenKeys: { [key: string]: boolean } = {};

		const addOption = (dateUsageKey: string | undefined, displayDate: string | undefined) => {
			if (!dateUsageKey || seenKeys[dateUsageKey]) {
				return;
			}
			seenKeys[dateUsageKey] = true;
			options.push({
				dateUsageKey,
				displayDate: displayDate || dateUsageKey,
				sortValue: this.parseDateUsageKey(dateUsageKey),
			});
		};

		(report.dailyUsageSummaries || []).forEach(summary =>
			(summary.dailyUsageCharges || []).forEach(charge =>
				addOption(charge.dateUsageKey, charge.displayDate)));

		(report.payments || []).forEach(payment =>
			addOption(payment.dateUsageKey, payment.chargeDateDisplay));

		(report.nonRecurringBillingCharges || []).forEach(charge =>
			addOption(charge.dateUsageKey, charge.chargeDateDisplay));

		(report.nonRecurringServiceCharges || []).forEach(summary =>
			(summary.nonRecurringServiceCharges || []).forEach(charge =>
				addOption(charge.dateUsageKey, charge.chargeDateDisplay)));

		return options.sort((a, b) => a.sortValue - b.sortValue);
	}

	// Build the "MMYY" key for the current calendar month (e.g. July 2026 => "0726")
	// so the current month-to-date period can be selected by default.
	private getCurrentMonthKey(): string {
		const now = new Date();
		const month = now.getMonth() + 1;
		const monthStr = month < 10 ? '0' + month : '' + month;
		const year = now.getFullYear() % 100;
		const yearStr = year < 10 ? '0' + year : '' + year;
		return monthStr + yearStr;
	}

	// dateUsageKey is an "MMYY" string (e.g. "0726" => July 2026). Parse it into a
	// comparable timestamp so periods sort correctly across month and year boundaries.
	private parseDateUsageKey(dateUsageKey: string): number {
		if (!dateUsageKey || dateUsageKey.length < 4) {
			return Number.MAX_SAFE_INTEGER;
		}
		const month = parseInt(dateUsageKey.substring(0, 2), 10);
		const year = 2000 + parseInt(dateUsageKey.substring(2, 4), 10);
		if (isNaN(month) || isNaN(year)) {
			return Number.MAX_SAFE_INTEGER;
		}
		return new Date(year, month - 1, 1).getTime();
	}

	generateDownload(override: boolean = false) {
		this.is_loading = true;
		const tmp_txt = this.report_btn_text;
		this.report_btn_text = 'File is preparing for download'
		this.disable_button = true;
		const isEnglish = this.sharedService.isEnglish();
		this.usagePaymentsService.getSUPPdf(this.account_no, isEnglish,override ? undefined : this.selectedDate)
			.then(async res => {
				if (res.ok) {
					this.is_loader = false;
					const blob = res.blob();
					if (blob != null) {
						this.is_loading = false;
						this.report_btn_text = tmp_txt;
						this.disable_button = false;
						const monthYear = new DatePipe('en-US').transform(new Date(), 'MMMM yyyy');
						const filename = 'PogoEnergyUsageAndPaymentStatement_' + this.account_no.toString() + '_' + monthYear + '.pdf';
						FileSaver.saveAs(blob, filename);
					} else {
						this.sharedService.setHeaderErrorMessage('usage_payments', true, 'notification error', res.message);
						this.is_loading = false;
						this.report_btn_text = tmp_txt;
						this.disable_button = false;
					}
				}
			})
			.catch((err) => {
				this.is_loading = false;
				this.report_btn_text = tmp_txt;
				this.disable_button = true;
				this.sharedService.setHeaderErrorMessage('usage_payments', true, 'notification error',
					'There was an issue obtaining your report, please try again.');
			})
	}

  protected readonly undefined = undefined;
}



// WEBPACK FOOTER //
// ./src/app/payment/usage-payments/usage-payment-details/usage-payment-details.component.ts